import React from 'react'
import Evaluation from '../Components/Attendance/Evaluation/Evaluation'

const AttendanceEvaluationPage = () => {
  return (
    <div style={{padding:"8px 0px"}} className='NewFormBackColor'>
      <Evaluation/>
    </div>
  )
}

export default AttendanceEvaluationPage
